import React, { useEffect } from 'react'
import { useState } from 'react'
import { Mail, Lock, Check, Circle, X, Eye } from 'react-feather'
import { Link, useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Input, Modal, ModalBody, ModalHeader } from 'reactstrap'

import AxiosInstance from 'utils/AxiosInstance'
import logoLight from './images/kiwi-full-logo.svg'
import loginSideGraphic from './images/login_side_graphic.png'
import { userLogin } from 'store/user/actions'
import './style.scss'
import './style.css'
// Leon global css
import '../../../assets/css/Global/style.css'
import { assignUserToCourse } from 'store/AllCourses/actions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-toastify'

const Login = (props) => {
  const history = useHistory()
  const dispatch = useDispatch()

  const [enrollmentSettings, setEnrollmentSettings] = useState(null)

  const [isGdprFormOpen, handleClickGdprForm] = useState(false)
  const [email, setEmailLogin] = useState('')
  const [password, setPasswordLogin] = useState('')
  const { theme } = useSelector((state) => state.themeConfig)

  const [canSignup, setCanSignup] = useState(false)

  const [isLoading, onLoad] = useState(false)
  const [showPassword, setShowPassword] = useState(false)

  // Parse query parameters for preview images
  const urlParams = new URLSearchParams(window.location.search)
  const previewBackgroundImage = urlParams.get('backgroundImage')
  const previewLogoImage = urlParams.get('logoImage')

  const publicCourseId = localStorage.getItem('public_catalog_course_id')

  const onLogin = (e) => {
    onLoad(true)
    e.preventDefault()

    const data = { email, password }

    AxiosInstance.post('/authenticate', data)
      .then((res) => {
        if (res && res.token) {
          localStorage.setItem('token', res.token)
          localStorage.setItem('top_proxy', res.token)
          console.log('res.token', typeof res.token)
          dispatch(
            userLogin(() => {
              // if (res.reset) {
              //   history.push('/auth/first-login')
              // } else {
              if (enrollmentSettings?.enrollment_type === 2) {
                history.push(`/public-catalog/${publicCourseId}`)
                localStorage.removeItem('public_catalog_course_id')

                return
              }
              if (publicCourseId) {
                history.push(`/course/${publicCourseId}`)
                dispatch(assignUserToCourse(publicCourseId, true))
                localStorage.removeItem('public_catalog_course_id')
              } else {
                history.push('/dashboard')
              }
              // }
            }),
          )
          onLoad(true)
        } else {
          localStorage.removeItem('token')
          alert('invalid login')
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .finally(() => {
        onLoad(false)
      })
  }

  const onChangeEmail = (event) => {
    setEmailLogin(event.target.value)
  }
  const onChangePassword = (event) => {
    setPasswordLogin(event.target.value)
  }
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  useEffect(() => {
    AxiosInstance.get('/settings/auth').then((data) =>
      setCanSignup(data.allow_signup),
    )
  }, [])

  useEffect(() => {
    if (publicCourseId) {
      AxiosInstance.get(`courses/enrollment-settings/${publicCourseId}`).then(
        (data) => setEnrollmentSettings(data),
      )
    }
  }, [publicCourseId])

  useEffect(() => {
    const handleMessage = (event) => {
      // Security check: ensure message is from your admin site
      if (event.origin !== 'http://localhost:5173') return

      if (event.data.type === 'UPDATE_PREVIEW_IMAGES') {
        const { backgroundImage, logoImage } = event.data

        // Update background image
        const heroImage = document.querySelector('.hero-image')
        if (heroImage && backgroundImage) {
          heroImage.src = backgroundImage
        }

        // Update logo image
        const logoImg = document.querySelector('.light-image')
        if (logoImg && logoImage) {
          logoImg.src = logoImage
        }
      }
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  return (
    <div className='modern-login'>
      <div className='underlay d-none d-xl-block'></div>
      <div className='d-flex align-items-center h-100'>
        <div className='col-md-6 col-lg-7 col-xl-8 d-none d-md-block px-0 position-relative'>
          <div className='hero is-fullheight is-image'>
            <div className='hero-body ' style={{ height: '100vh' }}>
              <div className='h-100 d-flex align-items-center'>
                <div
                  style={{
                    height: '100vh',
                    width: '100vw',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  // className='col'
                >
                  <img
                    className='hero-image-blur'
                    src={
                      previewBackgroundImage ||
                      (theme.background && theme.background.url
                        ? theme.background.url
                        : loginSideGraphic)
                    }
                    alt=''
                    aria-hidden='true'
                  />
                  <img
                    className='hero-image'
                    src={
                      previewBackgroundImage ||
                      (theme.background && theme.background.url
                        ? theme.background.url
                        : loginSideGraphic)
                    }
                    alt=''
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-6  col-lg-5 col-xl-4 px-0 is-relative '>
          <a className='top-logo mt-md-5' href='/'>
            <img
              className='light-image'
              src={
                previewLogoImage ||
                (theme.loginLogo && theme.loginLogo.url
                  ? theme.loginLogo.url
                  : logoLight)
              }
              alt=''
            />
            {/* <img
              className='dark-image'
              src='assets/img/logos/logo/logo-light.svg'
              alt=''
            /> */}
          </a>

          <div className='is-form mt-2 px-lg-3' style={{ paddingTop: '50px' }}>
            <div className='hero-body'>
              <div className='form-text'>
                <h2>Log In</h2>
                <p className='mb-0 text-sm'>Welcome back to your account.</p>
              </div>

              <form
                id='login-form'
                className='login-wrapper'
                onSubmit={onLogin}
              >
                <div className='control has-validation'>
                  <Input
                    type='text'
                    className='input'
                    placeholder=''
                    value={email}
                    onChange={onChangeEmail}
                  />
                  <small className='error-text'>This is a required field</small>
                  <div className='auth-label'>Email Address</div>
                  <div className='auth-icon'>
                    <Mail />
                  </div>
                  <div className='validation-icon is-success'>
                    <div className='icon-wrapper'>
                      <Check />
                    </div>
                  </div>
                  <div className='validation-icon is-error'>
                    <div className='icon-wrapper'>
                      <X />
                    </div>
                  </div>
                </div>
                <div className='control has-validation'>
                  <Input
                    type={showPassword ? 'text' : 'password'}
                    className='input'
                    value={password}
                    onChange={onChangePassword}
                  />
                  <div className='auth-label'>Password</div>
                  <div className='eye' onClick={togglePasswordVisibility}>
                    <Eye />
                  </div>
                  <div className='auth-icon'>
                    <Lock />
                  </div>
                </div>

                <div className='control is-flex'>
                  <div className='d-flex'>
                    <label className='remember-toggle'>
                      <input type='checkbox' />
                      <span className='toggler'>
                        <span className='active'>
                          <Check />
                        </span>
                        <span className='inactive'>
                          <Circle />
                        </span>
                      </span>
                    </label>
                    <div className='remember-me mt-2'>Remember Me</div>
                  </div>
                  <Link to='/auth/forgot-password'>
                    <a id='forgot-link'>Forgot Password?</a>
                  </Link>
                </div>
                <div className='col-12 px-0 '>
                  <div className='button-wrap text-center d-flex flex-column align-items-center justify-content-center text-center'>
                    <button
                      onClick={onLogin}
                      id='login-submit'
                      type='submit'
                      className='btn text-white login-button blue'
                      style={{
                        backgroundColor: '#00adf2',
                      }}
                    >
                      {isLoading ? 'Loading...' : 'Login Now'}
                    </button>
                    {canSignup ? (
                      <>
                        <small className='text-center justify-content-center mt-3'>
                          Don't have an account?{' '}
                          <Link to='/auth/signup'>Signup instead</Link>
                        </small>
                      </>
                    ) : null}
                  </div>
                </div>
                <div className='px-0 text-center d-flex justify-content-center'>
                  <div
                    className='data-agree col-8'
                    onClick={() => handleClickGdprForm(true)}
                  >
                    Data Processing Agreement
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <button
          onClick={() => (window.location.href = '/public-catalog')}
          className='btn btn-info link-centered d-flex align-items-center'
        >
          Public Catalog{' '}
          <FontAwesomeIcon icon={faArrowRight} className='ml-3' />
        </button>
      </div>
      {isGdprFormOpen ? (
        <GdprForm
          handleClickGdprForm={handleClickGdprForm}
          isOpen={isGdprFormOpen}
        />
      ) : null}
    </div>
  )
}
const GdprForm = (props) => {
  return (
    <Modal isOpen={props.isOpen} size='lg' centered>
      <ModalHeader toggle={() => props.handleClickGdprForm(false)}>
        Data Processing Agreement
      </ModalHeader>
      <ModalBody>
        <p>
          EDUonGo operates on behalf of Tazikis as the provider of Kiwi and the
          Create service GDPR-related requests by Create users can be emailed to
          EDUonGo at gdpr@startkiwi.com. These can be any of the six core GDPR
          requests: Subject access request (where the requester’s data is being
          held) Rectification (to correct inaccurate data) Erasure (to delete
          all data for the requester) Restriction of process (to not include the
          requester’s data in processing) Receive personal data (to receive
          export of the requester’s data) Object (to object to the requester’s
          data having been held and request to delete) EDUonGo will acknowledge
          the request within 2 days of receiving it, via a reply to the email
          address from which the request was sent (or provided within the
          request). EDUonGo will then take steps to validate the
          request/authenticate the requester. For Create, in many cases this
          will involve the assistance of Tazikis, the franchisee or former
          employer on whose behalf EDUonGo is operating the training system
          which the requester was using. If not confirmed to be valid, the
          requester will receive a reply via email indicating why the request
          could not be validated and asking for further information if
          necessary. If confirmed valid, EDUonGo will provide a response by
          email within 30 days indicating the results of the executed request
          (including a data export if applicable), or why it could not be
          executed if it was not.
        </p>
      </ModalBody>
    </Modal>
  )
}

export default Login
